import React, { useState } from 'react';

const AddSensorFilterPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showAddSensorFilterPopup,setShowAddSensorFilterPopup] = useState<boolean>(false);

    const addSensorFilterToggleHandler = () => {
        setShowAddSensorFilterPopup(!showAddSensorFilterPopup);
    }
	
	return <Component showAddSensorFilterPopup={showAddSensorFilterPopup} addSensorFilterToggleHandler={addSensorFilterToggleHandler} {...props}/>;
};

export default AddSensorFilterPopupHOC;   